import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_CARGO_DELIVERY_FREQUENT_VEHICLES,
  FLAG_GETTING_CARGO_DELIVERY_FREQUENT_VEHICLES,
  GET_CARGO_DELIVERY_FREQUENT_VEHICLES,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_CARGO_DELIVERY_FREQUENT_VEHICLES:
      return state.setIn(['all', 'loading'], payload);
    case GET_CARGO_DELIVERY_FREQUENT_VEHICLES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_CARGO_DELIVERY_FREQUENT_VEHICLES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};
